<template>

    <div class="webar" id="webar"></div>

</template>

<script>

    /* global THREE, THREEx */

    let vm = {};

    export default {

        name: 'WebAr',

        data() {
            return {
                container: null,
                renderer: null,
                onRenderFns: [],
                scene: null,
                camera: null,
                domEvents: null,
                arToolkitSource: null,
                arToolkitContext: null,
                markers: {
                    markerC: null
                },
                markerCControls: null,
                smoothedRootC: null,
                smoothedControlsC: null,
                loadingMgrC: null,
                loadingMgrCComplete: false,
                video: null,
                videoHasStarted: false,
                lastTimeMsec: null,
                cameraParamFile: 'data/camera_para.dat',
                patternFiles:       {
                    markerC: 'data/pattern-marker-color-55.patt'
                },
                textures: {
                    initiate: 'images/initiate.png'
                },
                videos: {
                    demoReel: 'video/Xavier_Creative_Creative_house_v15.mp4'
                },
                isMobile: {
                    Android: function() {
                        return navigator.userAgent.match(/Android/i);
                    },
                    BlackBerry: function() {
                        return navigator.userAgent.match(/BlackBerry/i);
                    },
                    iOS: function() {
                        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                    },
                    Opera: function() {
                        return navigator.userAgent.match(/Opera Mini/i);
                    },
                    Windows: function() {
                        return navigator.userAgent.match(/IEMobile/i);
                    }
                },
                isMarkerCVisible: false,
                isMarkerClicked: false,
                userHasClicked: false,
                userHasClickedAudio: false,
                assetsLoadedC: false
            }
        },

        computed: {
            any: function() {
                return (this.isMobile.Android() || this.isMobile.BlackBerry() || this.isMobile.iOS() || this.isMobile.Opera() || this.isMobile.Windows());
            },
            readyToScan: function() {
                return this.loadingMgrCComplete;
            }
        },

        created() {
            vm = this;
        },

        mounted() {
            vm.container = document.getElementById('webar');
            this.initWebAR();
        },

        methods: {

            initWebAR() {

                vm.initRenderer();
                vm.initScene();
                vm.initCamera();
                vm.initArToolkitSource();
                vm.initArToolkitContext();


                /////////////
                // markerC //
                /////////////

                vm.markers.markerC = new THREE.Group();
                vm.markers.markerC.name = 'markerC';

                vm.markerCControls = new THREEx.ArMarkerControls(vm.arToolkitContext, vm.markers.markerC, {
                    type: 'pattern',
                    patternUrl: vm.patternFiles.markerC
                });

                vm.markerCControls.addEventListener('markerFound', function(evt) {
                    vm.isMarkerCVisible = true;
                    vm.video.muted = false;
                });

                vm.smoothedRootC = new THREE.Object3D();
                vm.scene.add(vm.smoothedRootC);

                vm.smoothedControlsC = new THREEx.ArSmoothedControls(vm.smoothedRootC, {
                    lerpPosition: 0.4,
                    lerpQuaternion: 0.3,
                    lerpScale: 1,
                    lerpStepDelay: 1/30,
                    minVisibleDelay: 0.0,
                    minUnvisibleDelay: 0.25
                });

                THREE.noVideoTextureSupport = true;

                vm.loadingMgrC = new THREE.LoadingManager();
                vm.loadingMgrC.onStart = function(url, loaded, total) {
                    //vm.$eventBus.$emit('state:change', { state: 'loading' });
                    console.log('Started loading file:', url, '.\nLoaded', loaded, 'of', total, 'files.');
                };
                vm.loadingMgrC.onLoad = function() {
                    vm.loadingMgrCComplete = true;
                    if (vm.readyToScan) {
                        //vm.$eventBus.$emit('state:change', { state: 'scanning' });
                    }
                    console.log('Loading [SCENE_C] complete!');
                };
                vm.loadingMgrC.onProgress = function(url, loaded, total) {
                    //vm.$eventBus.$emit('state:change', { state: 'loading' });
                    console.log('Loading file:', url, '.\nLoaded', loaded, 'of', total, 'files.');
                };
                vm.loadingMgrC.onError = function(url) {
                    //vm.$eventBus.$emit('state:change', { state: 'loadingerror' });
                    console.log('There was an error loading', url);
                };


                ////////////
                // sceneC //
                ////////////

                let vWidth = 1280;
                let vHeight = 720;
                let scale = 3.1;

                function loadVideo(evt) {
                    vm.video.load(evt);

                    let videoTexture = new THREE.VideoTexture(vm.video);
                    videoTexture.minFilter = THREE.LinearFilter;
                    videoTexture.format = THREE.RGBFormat;
                    videoTexture.crossOrigin = 'anonymous';

                    let plateMaterial = new THREE.MeshBasicMaterial({ map: videoTexture, transparent: false });

                    let platePlane = new THREE.Mesh(new THREE.PlaneGeometry(vWidth / vWidth, vHeight / vWidth), plateMaterial);
                    platePlane.scale.set(scale, scale, scale);
                    platePlane.position.set(0, 0, 0);
                    platePlane.rotation.set(-Math.PI / 2, 0, 0); // lay flat on marker

                    vm.smoothedRootC.add(platePlane);

                    vm.videoHasStarted = true;
                }

                vm.video = document.createElement('video');
                vm.video.width = vWidth;
                vm.video.height = vHeight;
                vm.video.src = vm.videos.demoReel;
                vm.video.muted = true;
                vm.video.setAttribute('playsinline', '');
                vm.video.setAttribute('webkit-playsinline', '');
                vm.video.setAttribute('muted', '');
                vm.video.setAttribute('preload', 'none');

                let iWidth = 1024;
                let iHeight = 512;

                // interaction plane
                let initiatePlateTexture = new THREE.TextureLoader(vm.loadingMgrC).load(vm.textures.initiate);
                let initiateMaterial = new THREE.MeshBasicMaterial({ map: initiatePlateTexture, transparent: true });
                let initiatePlane = new THREE.Mesh(new THREE.PlaneGeometry(iWidth/iWidth, iHeight/iWidth), initiateMaterial);
                initiatePlane.visible = true;
                initiatePlane.scale.set(scale, scale, scale);
                initiatePlane.position.set(0, 0, 0);
                initiatePlane.rotation.set(-Math.PI / 2, 0, 0); // lay flat on marker

                vm.smoothedRootC.add(initiatePlane);

                let clickEvent = vm.any ? 'touchstart' : 'click';
                document.addEventListener(clickEvent, onWindowClick);

                document.addEventListener(clickEvent, function(evt) {
                    if (evt.target && evt.target.id === 'video-mute-toggle') {
                        toggleAudio();
                    }
                });

                function onWindowClick(evt) {
                    vm.userHasClicked = true;
                    loadVideo(evt);
                    toggleAudio();
                    document.removeEventListener(clickEvent, onWindowClick);
                }

                function toggleAudio(evt) {
                    vm.video.muted = !vm.video.muted;
                }

                vm.onRenderFns.push(function(delta) {
                    vm.isMarkerVisible = vm.markers.markerC.visible;

                    vm.smoothedControlsC.update(vm.markers.markerC);

                    if (vm.isMarkerVisible && vm.userHasClicked) {
                        initiatePlane.visible = false;
                        if (vm.video) { setTimeout(() => {
                            vm.video.play();
                        }, 50); }
                    } else {
                        if (vm.video) { setTimeout(() => {
                            vm.video.pause();
                        }, 50); }
                    }

                    vm.renderer.render(vm.scene, vm.camera);
                });


                // handle spinner show/hide
                vm.onRenderFns.push(function() {
                    if (vm.markers.markerC.visible === true) {
                        vm.$eventBus.$emit('marker:found', { state: true });
                    } else {
                        vm.$eventBus.$emit('marker:found', { state: false });
                    }
                });


                // render the damn thing already!
                vm.onRenderFns.push(function() {
                    vm.renderer.render(vm.scene, vm.camera);
                });


                // animation loop
                requestAnimationFrame(function animate(nowMsec) {
                    requestAnimationFrame(animate);
                    vm.lastTimeMsec = vm.lastTimeMsec || nowMsec - 1000 / 60;
                    let deltaMsec = Math.min(200, nowMsec - vm.lastTimeMsec);
                    vm.lastTimeMsec = nowMsec;
                    vm.onRenderFns.forEach(function(onRenderFn) {
                        onRenderFn(deltaMsec/1000, nowMsec/1000);
                    });
                });

            },

            /**
             * @method initRenderer
             * @description
             */
            initRenderer() {
                vm.renderer = new THREE.WebGLRenderer({
                    antialias: false,
                    alpha: true
                });

                vm.renderer.setClearColor(new THREE.Color('lightgrey'), 0);
                vm.renderer.setSize(2048, 2048);
                vm.renderer.domElement.style.width = '100%';
                vm.renderer.domElement.style.height = '100%';
                vm.renderer.domElement.style.overflow = 'hidden';
                vm.renderer.domElement.style.margin = '0';
                vm.renderer.domElement.style.padding = '0';
                vm.renderer.setClearColor(0x000000, 0);

                vm.container.appendChild(vm.renderer.domElement);
            },

            /**
             * @method initScene
             * @description
             */
            initScene() {
                vm.scene = new THREE.Scene();
            },

            /**
             * @method initCamera
             * @description
             */
            initCamera() {
                //vm.camera = new THREE.Camera();
                vm.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
                vm.scene.add(vm.camera);
            },

            /**
             * @method initArToolkitSource
             * @description
             */
            initArToolkitSource() {
                vm.arToolkitSource = new THREEx.ArToolkitSource({
                    sourceType: 'webcam',
                    sourceUrl: null
                });

                vm.arToolkitSource.init(function onReady() {
                    onResize();
                });

                window.addEventListener('resize', function() {
                    onResize();
                });

                function onResize() {
                    vm.arToolkitSource.onResizeElement();
                    vm.arToolkitSource.copyElementSizeTo(vm.renderer.domElement);
                    if (vm.arToolkitContext.arController !== null) {
                        vm.arToolkitSource.copyElementSizeTo(vm.arToolkitContext.arController.canvas);
                    }
                }
            },

            /**
             * @method initArToolkitContext
             * @description
             */
            initArToolkitContext() {
                vm.arToolkitContext = new THREEx.ArToolkitContext({
                    debug: false,
                    detectionMode: 'mono',
                    cameraParametersUrl: vm.cameraParamFile,
                    maxDetectionRate: 30,
                    canvasWidth: 640,
                    canvasHeight: 480,
                    imageSmoothingEnabled: true
                });

                vm.arToolkitContext.init(function onCompleted() {
                    vm.camera.projectionMatrix.copy(vm.arToolkitContext.getProjectionMatrix());
                });

                vm.onRenderFns.push(function () {
                    if (vm.arToolkitSource.ready === false) { return; }
                    vm.arToolkitContext.update(vm.arToolkitSource.domElement);
                });
            }

        }

    }

</script>

<style scoped lang="scss">

    .webar {
        position: relative;
        z-index: 5;
    }

</style>
